import * as moment from 'moment'
import * as React from 'react'
import { Col, Row } from '../ui/grid'

interface Props {
    date: moment.Moment
}

export class NoData extends React.PureComponent<Props> {
    public render() {
        return (
            <Row>
                <Col width={6} centered widthSmall={12}>
                    <div className="alert alert-warning">
                        <h4>No data available</h4>
                        <p>
                            There is no data available for the selected time range.
                            {this.isVeryRecent() ? (
                                <span>
                                    It might be that calculation of historical data for that time range is not done, yet. Please come back
                                    later.
                                </span>
                            ) : (
                                <span>
                                    It seems your application did not record any data during the selected time range so we are unable to
                                    compare it.
                                </span>
                            )}
                        </p>
                    </div>
                </Col>
            </Row>
        )
    }

    private isVeryRecent = () => {
        return this.props.date.isAfter(moment().subtract(3, 'days'))
    }
}
